import { BodilColor } from '~src/branding';
import { CheckmarkContainer } from '~src/components/Carousel/style';
import { Icon } from '~src/components/Icon';
import { TextNorlys } from '~src/components/Text';
import { useBranding } from '~src/context/BrandingContext';
import { formatCurrency } from '~src/util';

import { CheckmarkOutlined, Container, Header, Wrapper } from '../../style';
import { ProductCardCommonProps } from '../../types';

export const ProductCardCommonNorlys = ({
  style,
  selected,
  tag,
  onClick,
  price,
  productLabel,
  quantity,
  quantityLabel,
  flipped,
  setFlipped,
  children,
}: ProductCardCommonProps) => {
  const { darkColor, lightTextColor } = useBranding();

  const textColor = selected ? 'white' : 'black';

  return (
    <Wrapper>
      <Container {...{ onClick, selected, style, backgroundColor: lightTextColor, backgroundColorSelected: darkColor }}>
        {selected && (
          <CheckmarkContainer>
            <CheckmarkOutlined />
          </CheckmarkContainer>
        )}

        <Header>
          <TextNorlys
            fontType='heading'
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            color={textColor}
            onClick={e => {
              e.stopPropagation();
              setFlipped(!flipped);
            }}
          >
            <Icon.Flip height={19} color={selected ? 'white' : 'grey'} />
            {flipped ? 'Tilbage' : 'Mere info'}
          </TextNorlys>

          {tag && (
            <TextNorlys
              fontType='heading'
              style={{
                background: BodilColor.base.grey,
                borderRadius: 20,
                padding: '4px 16px',
                color: 'white',
              }}
            >
              {tag}
            </TextNorlys>
          )}
        </Header>

        {children}

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <TextNorlys fontSize={20} style={{ fontWeight: 'bold' }} color={textColor}>
            {formatCurrency(price ?? 0, { addVAT: true, decimals: 0 })}
          </TextNorlys>
          <TextNorlys fontSize={12} color={textColor}>
            (inkl. standard montage)
          </TextNorlys>
        </div>

        {quantity ? (
          <TextNorlys
            color={textColor}
            fontType='heading'
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {quantity} {quantityLabel}
          </TextNorlys>
        ) : null}

        <TextNorlys
          fontSize={16}
          color={textColor}
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0 16px 16px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {productLabel}
        </TextNorlys>
      </Container>
    </Wrapper>
  );
};
